import { Project } from '@linqpal/models/src/mst/Project'
import { types } from 'mobx-state-tree'
import { editableModel } from '@linqpal/models'
import makeInspectable from 'mobx-devtools-mst'

export enum Sidebar {
  EDIT = 'EDIT',
  VIEW = 'VIEW',
}
export type SidebarType = Sidebar.EDIT | Sidebar.VIEW
const ChosenProject = types
  .compose(
    types
      .model({
        sidebarFor: Sidebar.VIEW,
        isOpenedSidebar: types.optional(types.boolean, false),
        chosenProject: types.maybeNull(Project),
      })
      .views(views)
      .actions(chosenActions),
    editableModel(),
  )
  .named('ChosenProject')

function chosenActions(self: any) {
  return {
    setIsOpenedSidebar: (bool: boolean, sidebarFor: SidebarType) => {
      self.isOpenedSidebar = bool
      self.sidebarFor = sidebarFor
    },
    setSidebar: (bool: boolean) => (self.isOpenedSidebar = bool),
    setSidebarFor: (type: SidebarType) => (self.sidebarFor = type),
  }
}
function views() {
  return {}
}

const chosenProjectStore = ChosenProject.create({})
makeInspectable(chosenProjectStore)

export default chosenProjectStore
